export const PLAN_RANK = {
  free: 0,
  standard: 1,
  plus: 2,
  premium: 3,
};

export const FEATURE_MIN_PLAN = {
  gift_fund: "free",
  ai_moderation: "plus",
  hd_storage: "standard",
  zip_export: "standard",
  best_of: "standard",
  organizer_picks: "standard",
  photo_missions: "plus",
  moments: "free",
  live_wall: "plus",
  priority_support: "premium",
};

export function normalizePlan(plan = "free") {
  const value = String(plan || "free").trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(PLAN_RANK, value) ? value : "free";
}

export function isPlanAtLeast(plan, minimumPlan) {
  const current = normalizePlan(plan);
  const minimum = normalizePlan(minimumPlan);
  return PLAN_RANK[current] >= PLAN_RANK[minimum];
}

export function getMinimumPlanForFeature(feature) {
  return FEATURE_MIN_PLAN[feature] || "free";
}

export function hasPlanFeature(plan, feature) {
  return isPlanAtLeast(plan, getMinimumPlanForFeature(feature));
}
